import { render } from "./EditDoc.vue?vue&type=template&id=e2d31e2a&scoped=true"
import script from "./EditDoc.vue?vue&type=script&lang=js"
export * from "./EditDoc.vue?vue&type=script&lang=js"

import "./EditDoc.vue?vue&type=style&index=0&id=e2d31e2a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d31e2a"]])

export default __exports__